import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/69fc4a24f6558f00141013ea/unoc/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fc4a24f6558f00141013ea/unoc/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69fc4a24f6558f00141013ea/unoc/src/components/Navbar.tsx");
